<!-- container-xxl -->
<div class="content-wrapper aboutus-content-wrapper-container p-0 content-aboutus-outer-container">
  <app-content-header [contentHeader]="contentHeader"></app-content-header>
  <div class="content-body content-body-outer-img-container">
    <img src="assets\images\about-us-img\Group 158.png" alt="about-us">
  </div>
  <div class="content-body">
    <!-- app e-commerce details start -->
    <section class="app-ecommerce-details">
      <!-- <div class="card"> -->
      <!-- Related Products starts -->
      <!-- <div class="card-body"> -->

      <div class="col-xl-12 aboutus-main-news-bar-outer-contaner">
        <div class="card">
          <div class="card-body">
            <div class="row row-cotainer">
              <div class="col-md-2 black-border black-border-right"></div>
              <div class="col-md-10 black-border"></div>
              <div class="col-md-2 black-border-right border-radius-left">
                <ul ngbNav #verticalNav="ngbNav" [activeId]="1" class="nav-pills flex-column">
                  
                  <li [ngbNavItem]="1">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">Roles and Responsibilities</span>
                      <!-- <span class="d-none d-sm-block ">Roles and Responsibilities of the R&D Division</span> -->
                      <span class="d-none d-sm-block ">Roles and Responsibilities</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ul>
                        <!-- <li>Gap Assessment of RE technologies</li>
                        <li>Identifying thrust Areas for research</li>
                        <li>RD&D Project Appraisal, evaluation, and sanctioning funds</li>
                        <li>Monitoring Project Implementation</li>
                        <li>Awarding Innovation</li>
                        <li>Development of Technology Roadmaps</li>
                        <li>Strengthening of Autonomous Institutions</li>
                        <li>International collaboration on RD&D</li>
                        <li>Implement bilateral programmes with international organisations focused on innovative
                          applications of Solar</li> -->
                        <li>Identifying thrust areas for research and developing technology roadmaps for various RE
                          technologies </li>
                        <li>Implementing Renewable Energy – Research and Technology Development (RE-RTD) Programme that
                          includes project Appraisal, evaluation, sanctioning funds, and monitoring</li>
                        <li>Awarding Innovation </li>
                        <li><a class="link" style="padding:0 !important;" ngbNavLink [ngbNavItem]="8">Strengthening of Autonomous Institutions</a></li>
                        <li>International collaboration on RD&D</li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="2">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">Our Work</span>
                      <span class="d-none d-sm-block ">Our Work</span>
                    </a>
                    <ng-template ngbNavContent>
                      <p class="span-font" style="color:var(--secondary-color) !important;"><span class="span-font">A.</span> Fund RD&D projects underneath the Renewable Energy – Research and Technology Development
                        (RE-RTD) Programme </p>
                      <ul>
                        <li><a routerLink="/resources" class="link">We support projects that drive technology
                            innovation, and commercialisation, and
                            promote the competitiveness of industries through technology transfer and indigenous
                            manufacturing, in line with the thrust areas set under the Renewable Energy – Research and
                            Technology Development (RE-RTD) programme</a> </li>
                        <li><a routerLink="/apply-for-funding" class="link">The R&D Division issues Call for Proposals
                            periodically to invite applications from research
                            institutes,
                            Universities, Not for Profit, industry, and start-ups, underneath the RE-RTD Programme.</a>
                        </li>
                        <li>Technologies in focus - solar thermal, solar PV, biogas, onshore and offshore wind,
                          hybrid RE, energy storage, small hydropower, hydrogen, and fuel cells, geothermal,
                          space-saving PV applications, etc.</li>
                          <br>
                        <p><a routerLink="/apply-for-funding" class="link">To know more about the application process
                            under RE-RTD Programme, please refer
                            ‘Apply for Funding’ to know more about our thrust
                            areas. </a></p>
                        <p><a routerLink="/key-initiatives" class="link">Read more about our ongoing projects on Key
                            Projects.</a></p>

                      </ul>
                      <p class="span-font" style="color:var(--secondary-color) !important;"><span class="span-font">B.</span> Promote India’s Innovation Spirit</p>
                      <ul>
                        <li><a href="{{documentURL}}/Applyforfunding_typeofactivities_abhinavsoch.pdf" class="link">We
                            award innovative ideas in new and renewable energy under “Abhinav Soch Nayee
                            Sambhawanayen” scheme.</a></li>
                        <li>To mark 75 years of India’s independence, we have ramped up efforts to encourage
                          innovation from India. MNRE to soon launch a webpage on R&D Innovation Showcase on Renewables</li>
                      </ul>
                      <p class="span-font" style="color:var(--secondary-color) !important;"><span class="span-font">C.</span> Bilateral Programmes</p>
                      <ul>
                        <li>Under the ambit of Azadi Ka Amrit Mahotsav (AKAM), MNRE in partnership with GIZ is
                          supporting ideas (Ideas@75) for the pilot demonstration of new and innovative solar
                          applications under the bilateral project titled Innovative Solar Areas (IN-Solar). The
                          objectives of the IN-Solar project are (i) to find innovative ways to expand the application
                          of photovoltaics to optimize land use; and assess the technical potential of space-saving
                          photovoltaic technologies such as floating solar PV, agrivoltaics, rail/road integrated PV,
                          and building-integrated PV.</li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="3">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">MNRE R&D Policy</span>
                      <span class="d-none d-sm-block ">MNRE R&D Policy</span>
                    </a>
                    <ng-template ngbNavContent>
                      <p><a routerLink="/resources" class="link">The R&D Policy details the implementation mechanism for projects funded under the RE-RTD
                        Programme.</a></p>
                      <ul>
                        <li>Project identification</li>
                        <li>Project Proposal formulation</li>
                        <li>Project monitoring, appraisal, approval, financial support (sanction of grants), evaluation
                        </li>
                        <li>IPR sharing, T&C related to assets acquired under the projects</li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="4">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">Centres of Excellence for R&D</span>
                      <span class="d-none d-sm-block ">Centres of Excellence for R&D</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ul>
                        <li><a href="https://rnd.iitb.ac.in/node/101501" class="link"> National Centre for Photovoltaic
                            Research and Education (NCPRE), IIT-B </a><!--<a href="">National
                            centre
                            for Photovoltaic Research and Education (NCPRE) | Industrial Research and Consultancy Centre
                            (iitb.ac.in)</a>--></li>
                        <li><a href="https://www.hpnet.org/store/p13/AHEC_%28Alternate_Hydro_Energy_Center%29.html"
                            class="link"> Alternate Hydro Energy Centre </a> <!--<a href=""> AHEC (Alternate Hydro Energy Center)
                            (hpnet.org)</a>--></li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="5">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">MNRE’S Autonomous Institutes</span>
                      <span class="d-none d-sm-block ">MNRE’S Autonomous Institutes</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ul>
                        <li><a href="https://nise.res.in/" class="link"> National Institute of Solar Energy (NISE),
                            Gurugram</a><!-- | <a href=""> National Institute of
                        Solar Energy – National Institute of Solar Energy (nise.res.in)</a>--></li>
                        <li><a href="https://niwe.res.in/" class="link">National Institute of
                            Wind Energy</a> <!--<a href="">National Institute of Wind Energy
                            (niwe.res.in)</a>--></li>
                        <li><a href="https://www.nibe.res.in" class="link"> Sardar Swaran Singh National Institute of
                            Bioenergy
                            (SSS-NIBE), Kapurthala</a> </li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="6">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">PSUs</span>
                      <span class="d-none d-sm-block ">PSUs</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ul>
                        <li><a href="https://www.seci.co.in/" class="link"> Solar Energy Corporation of India (SECI)
                            Solar Energy Corporation of India
                            Limited(SECI), A Government of India Enterprise, Under Ministry of New and Renewable
                            Energy</a>
                        </li>
                        <li><a href="https://www.ireda.in/home" class="link">Indian Renewable Energy Development Agency
                            (IREDA)</a> </li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="7">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">International Collaboration Mechanisms on R&D</span>
                      <span class="d-none d-sm-block ">International Collaboration Mechanisms on R&D</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ul>
                        <li><a href="https://mnre.gov.in/international-relations/overview" class="link">International MoUs on R&D</a></li>
                        <li><a href="http://mission-innovation.net/our-members/india/plans-and-priorities/" class="link">Mission Innovation </a></li>
                        <li><a href="https://mnre.gov.in/isa/" class="link">International Solar Alliance (ISA)</a></li>
                      </ul>

                    </ng-template>
                  </li>
                  <li [ngbNavItem]="8">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">RD&D focus (indicative)</span>
                      <span class="d-none d-sm-block ">RD&D focus (indicative)</span>
                    </a>
                    <ng-template ngbNavContent>
                      <ul>
                        <!-- <li>Renewable Energy Resource Survey, Assessment and Mapping</li>
                        <li>Technology Benchmarking</li>
                        <li>Technology validation for scaling up/demonstration/commercialization</li>
                        <li>Capacity building</li>
                        <li>Technology development and demonstration, testing, and standardisation including through
                          international collaboration</li>
                        <li>Policy recommendations</li>
                        <li>Feedback to manufacturers for upgrades</li>
                        <li>Technology innovation</li>
                        <li>Cost reduction of new and renewable energy products and services</li>
                        <li>Read more about our ongoing projects on Key Project webpage</li> -->
                        <li>Renewable Energy Resource Survey, Assessment and Mapping</li>
                        <li>Technology Benchmarking</li>
                        <li>Technology validation for scaling up/ demonstration/ commercialization</li>
                        <li>Capacity building</li>
                        <li>Technology development and demonstration, testing, and standardisation including through
                          international collaboration</li>
                        <li>Policy recommendations</li>
                        <li>Feedback to manufacturers for upgrades</li>
                        <li>Technology innovation</li>
                        <li>Cost reduction of new and renewable energy products and services</li>
                        <li><a routerLink="/key-initiatives" class="link"> Read more about our ongoing projects on Key
                            Project webpage </a></li>
                      </ul>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="9">
                    <a ngbNavLink class="mb-2">
                      <span class="d-block d-sm-none">R&D Division Policies and Programmes</span>
                      <span class="d-none d-sm-block ">R&D Division Policies and Programmes</span>
                    </a>
                    <ng-template ngbNavContent>
                      <p>
                        <!-- The RE-RTD Programme is implemented in accordance with the R&D policy -->
                        The RE-RTD Programme is implemented in accordance with the R&D policy on <a
                          routerLink="/resources" class="link">Resources page</a>
                        and thrust areas on <a routerLink="/apply-for-funding" class="link">Apply for Funding page</a>
                      </p>
                      <!-- <p>The R&D Policy details out the implementation mechanism for projects funded under the RD&D
                        programme. </p> -->
                      <ul>
                        <!-- <li>Project identification</li>
                        <li>Project Proposal formulation</li>
                        <li>Project monitoring, appraisal, approval, financial support (sanction of grants), evaluation,
                        </li>
                        <li>IPR sharing, T&C related to assets acquired under the projects</li> -->
                        <li>The R&D Policy details out the implementation mechanism for projects funded under the RD&D
                          programme.</li>
                        <li>Project identification</li>
                        <li>Project Proposal formulation</li>
                        <li>Project monitoring, appraisal, approval, financial support (sanction of grants), evaluation,
                        </li>
                        <li>IPR sharing, T&C related to assets acquired under the projects</li>
                      </ul>
                    </ng-template>
                  </li>
                </ul>
              </div>
              <div class="col-md-10 border-radius-right">
                <div [ngbNavOutlet]="verticalNav" class="text-muted"></div>
              </div>
            </div><!-- end row -->
          </div><!-- end card-body -->
        </div><!-- end card -->
      </div><!-- end col -->


      <!-- <div class="aboutus-main-news-bar-outer-contaner">
          <div class="news-bar-box-outer-contaner back-color"></div>
          <div class="news-bar-box-tow-outer-contaner back-color"></div>
          <div class="news-bar-box-outer-contaner">
            <div class="news-bar-inner-contaner">role</div>
            <div class="news-bar-inner-contaner">role</div>
            <div class="news-bar-inner-contaner">role</div>
            <div class="news-bar-inner-contaner">role</div>
          </div>
         
          <div class="news-bar-box-tow-outer-contaner">
            <h3 class="text-center mb-1">RENEWABLE ENERGY RESEARCH AND TECHNOLOGY DEVELOPMENT PROGRAMME</h3>
            <p>Research, design, development and technology demonstration for its validation are one of the core requirements for the growth of New & Renewable Energy. Ministry of New & Renewable Energy (MNRE) supports research, design, technology development and demonstration for  renewable energy to develop new and renewable energy technologies, processes, materials, components, sub-systems, products & services, standards and resource assessment so as to indigenously manufacture new and renewable energy systems and devices. The objective of the programme is to make the industry globally competitive and renewable energy generation supply, self-sustainable/profitable and thereby contribute to increase share in total energy mix in the country.</p>
            <p>R&D Projects received from  R&D institutions /universities,  industries and NGO’s etc. in the field of solar, wind, solar-wind hybrid, storage, small hydro power, biogas, hydrogen and fuel cells, geothermal, etc. are considered by the Ministry for financial support.</p>
            
            <h4>Policy and Guidelines</h4>
            <p>A comprehensive policy framework on Renewable Energy Research and Technology Development Programme is in place to support R&D in new and renewable energy sector, including associating and supporting R&D earned out by industry for market development. Ministry provides up to 100% financial support to Government/non-profit research organizations/NGOs and up to 50 to 70% to industry.</p>
            <p>The policy framework provides guidelines for project identification, formulation, monitoring, appraisal, approval, and financial support. The R&D projects received from R&D/academic institutions, industries, etc. are evaluated through subject experts. The qualifying projects are appraised by R&D Project Appraisal Committees. The projects recommended by the committees are sanctioned to prospective implementing agencies. The projects are monitored by Monitoring Committees. Projects on completion are reviewed in Project Appraisal Committee Meetings for their achievements.</p>
            <h4>RD&D Focus</h4>
            <p>The RD&D efforts are continued with emphasis on cost reduction, reliability and efficiency improvement of renewable energy systems, components, and BOS.  The project in accordance with the R&D thrust area of the ministry in solar thermal, SPV, biogas, wind, wind-hybrid, storage, small Hydro Power, hydrogen, and fuel cells, geothermal, etc. are supported for RD&D Activity. The projects in other areas not covered under the R&D thrust areas are also considered for financial support based on their applications and practical importance.</p>
            <h4>Institutional Mechanism </h4>
          </div>
        </div> -->


    </section>
  </div>
</div>